import { h } from 'preact';
import { forwardRef } from 'preact/compat';
import { Button } from './TocPropsTypes';

interface TocMobileButtonProps extends Button {
	expanded: boolean;
	toggle: () => any;
	controls: string;
}

export const TocMobileButton = forwardRef<HTMLButtonElement, TocMobileButtonProps>((props, ref) => {
	return (
		<button
			ref={ref}
			aria-expanded={props.expanded}
			onClick={props.toggle}
			aria-controls={props.controls}
			className={'SP-Toc__button SP-Button--ghostBright'}
		>
			<svg className="SPi SPi-customer-arrow-down SPi-Toc__dropdown" aria-hidden="true" focusable="false">
				<use href="#SPi-customer-arrow-down" />
			</svg>
			<span className="SP-TocButton__text">{props.label}</span>
		</button>
	);
});
